import { Icon } from '@natera/material/lib/icon'
import { Collapsible } from 'radix-ui'
import { useState } from 'react'
import { renderInlineCode } from '~/shared/lib/inline-code'
import { Text } from '~/shared/ui'
import {
  CATEGORY_CHECKS,
  LABEL_FROM_PDF_RULE,
  REVIEW_RULE_SECTIONS,
  REVIEW_STEPS,
  type RuleItem,
} from '../config'

function RuleText({ item }: { item: RuleItem }) {
  return (
    <>
      {item.term && <span className="font-medium">{`${item.term}: `}</span>}
      {renderInlineCode(item.text)}
    </>
  )
}

export function ReviewRulesPanel() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Collapsible.Root
      className="border-divider rounded-lg border"
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Collapsible.Trigger className="flex w-full cursor-pointer items-center justify-between gap-2 border-none bg-transparent px-4 py-3 text-left outline-none">
        <Text appearance="SUBTITLE2">Review rules</Text>
        <Icon className="text-action-active">{isOpen ? 'expand_less' : 'expand_more'}</Icon>
      </Collapsible.Trigger>
      <Collapsible.Content className="border-divider flex flex-col gap-5 border-t px-4 py-4 text-[13px] leading-5">
        <div className="flex flex-col gap-1">
          <Text appearance="SUBTITLE2">For each document</Text>
          <ol className="m-0 flex flex-col gap-1 pl-5">
            {REVIEW_STEPS.map((step) => (
              <li key={step.term ?? step.text}>
                <RuleText item={step} />
              </li>
            ))}
          </ol>
          <p className="m-0 font-medium">{LABEL_FROM_PDF_RULE}</p>
        </div>
        {REVIEW_RULE_SECTIONS.map((section) => (
          <div
            key={section.title}
            className="flex flex-col gap-1"
          >
            <Text appearance="SUBTITLE2">{section.title}</Text>
            {section.intro && <p className="m-0">{section.intro}</p>}
            <ul className="m-0 flex list-disc flex-col gap-1 pl-5">
              {section.items.map((item) => (
                <li key={item.text}>
                  <RuleText item={item} />
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="flex flex-col gap-1">
          <Text appearance="SUBTITLE2">Checks for the categories that get auto-reviewed</Text>
          <table className="w-full border-collapse text-left">
            <thead>
              <tr className="text-text-secondary text-xs">
                <th className="border-divider border-b py-1 pr-3 text-left font-medium">
                  If you are considering…
                </th>
                <th className="border-divider border-b py-1 text-left font-medium">
                  Make sure it is not…
                </th>
              </tr>
            </thead>
            <tbody>
              {CATEGORY_CHECKS.map((check) => (
                <tr
                  key={check.considering}
                  className="align-top"
                >
                  <td className="border-divider border-b py-1.5 pr-3 wrap-anywhere">
                    {renderInlineCode(check.considering)}
                  </td>
                  <td className="border-divider border-b py-1.5 wrap-anywhere">
                    {renderInlineCode(check.notThese)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
